import { styled, Typography } from "@material-ui/core";
import Imgix from "react-imgix";

export const ImageWrapper = styled(Imgix)(({ theme }) => ({
  minWidth: "375px",
  objectFit: "cover",
  [theme.breakpoints.down(`sm`)]: {
    maxWidth: "600px"
  },
  [theme.breakpoints.only(`sm`)]: {
    width: "50%"
  },
  [theme.breakpoints.up(`md`)]: {
    width: "40%"
  }
}));

export const VideoWrapper = styled(`div`)(({ theme }) => ({
  position: "relative",
  minHeight: "375px",
  [theme.breakpoints.down(`sm`)]: {
    maxWidth: "600px"
  },
  [theme.breakpoints.only(`sm`)]: {
    width: "50%"
  },
  [theme.breakpoints.up(`md`)]: {
    width: "40%"
  }
}));

export const VideoContent = styled(`video`)(({}) => ({
  position: "absolute",
  height: "100%",
  width: "100%",
  objectFit: "cover"
}));

export const ContentPreTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Roobert",
  fontSize: "1.5rem",
  fontWeight: 600,
  lineHeight: "1.6rem",
  color: "#ACA9A3",
  letterSpacing: "1.5px",
  paddingBottom: "17px",
  [theme.breakpoints.down(`xs`)]: {
    padding: "16px 0 32px"
  }
}));

export const ContentTextTitle = styled(Typography)(({}) => ({
  fontFamily: "Reckless",
  fontSize: "5rem",
  fontWeight: 400,
  lineHeight: "5.6rem",
  letterSpacing: "-1px"
}));
